import { render } from "./AddChampsLibrePage.vue?vue&type=template&id=0487f186&ts=true"
import script from "./AddChampsLibrePage.vue?vue&type=script&lang=ts"
export * from "./AddChampsLibrePage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__